import { Button } from '@skin-seoul/design-system';
import type { ReviewImage } from '..';

interface ReviewImageGalleryProps {
  images: ReviewImage[];
  onViewAll?: () => void;
}

export const ReviewImageGallery = ({ images, onViewAll }: ReviewImageGalleryProps) => {
  const handleImageClick = () => {
    if (onViewAll) {
      onViewAll();
    }
  };

  const hasImages = images && images.length > 0;

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-[14px]">
        <p className="text-label-medium tablet:text-heading-h6 m-0">Images from reviews</p>
        {hasImages && (
          <Button
            variant="plain"
            className="max-h-fit text-neutral-400 text-label-small"
            onClick={onViewAll}
          >
            View all
          </Button>
        )}
      </div>
      {hasImages ? (
        <div
          className="flex flex-row gap-2 max-w-full overflow-x-auto"
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {images.map((image) => (
            <div
              key={image.id}
              className="flex-[0_0_100px] w-[100px] h-[100px] rounded-[8px] overflow-hidden cursor-pointer"
              onClick={handleImageClick}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={image.url}
                alt={image.alt}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center h-[100px] bg-[#f8f8f8] rounded-[8px] mt-2">
          <p className="text-[14px] text-[#6e6e6e] text-center m-0">No customer images yet</p>
        </div>
      )}
    </div>
  );
};

export default ReviewImageGallery;
